var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonCrosspost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    rpl: "",
    className: "mt-[1px] ml-[4px]",
    fill: "none",
    height: 20,
    "icon-name": "crosspost-outline",
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.934 11.723a.757.757 0 0 0-1.07-.015.757.757 0 0 0 .003 1.07l1.705 1.722h-4.571A4.69 4.69 0 0 1 7.263 10a4.69 4.69 0 0 1 4.738-4.5h4.571l-1.705 1.723a.757.757 0 0 0-.003 1.07.757.757 0 0 0 1.07-.016L18.86 5.32a.952.952 0 0 0 .249-.604.952.952 0 0 0-.252-.601l-2.93-2.898a.757.757 0 0 0-1.069-.003.757.757 0 0 0 .015 1.07L16.608 4H12a6.214 6.214 0 0 0-6.18 5.25H1.357a.772.772 0 0 0-.75.75c0 .398.353.75.75.75h4.464a6.214 6.214 0 0 0 6.18 5.25h4.607l-1.735 1.717a.758.758 0 0 0-.015 1.07.76.76 0 0 0 1.07-.004l2.932-2.901a.85.85 0 0 0 .003-1.2l-2.93-2.96Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCrosspost);
export default __webpack_public_path__ + "static/media/button-crosspost.78b168788dc0db3dcd99ef1421fb65ed.svg";
export { ForwardRef as ReactComponent };